"use strict";

import helpers from "./_helpers";

const Forms = () => {
    const init = () => {
        $(document).ready(function () {

            // Enable niceselect on nice-selected dropdowns
            $('.nice-select').niceSelect();
            $('.search-select').searchSelect();
            // Enable focus states
            $(document).on('click.nice_select', function(event) {
                $('.nice-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.nice-select').length !== 0) {
                    $(event.target).closest('.nice-select').parents('.form-group').addClass('focused');
                }
            });
            $(document).on('click.search_select', function(event) {
                $('.search-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.search-select').length !== 0) {
                    $(event.target).closest('.search-select').parents('.form-group').addClass('focused');
                }
            });
            // Refreshonselect
            $('.refreshonselect').on('change', function () {
                $(this).parents('form').find('.current-page').val(1);
                $('.nice-select').niceSelect('destroy');
                $('.search-select').searchSelect('destroy');
                $(this).parents('form').find('.ajax-submit').trigger('click');
                $('.nice-select').niceSelect();
                $('.search-select').searchSelect();
            });
            // Close nice select on click
            $('.nice-select ul li').click(function () {
                setTimeout(function () {
                    $('.nice-select').removeClass("open");
                }, 10);
            });

            $("input[type='date']").parent().addClass('date-field');
            /**
             * Handle input focus to animate labels
             */
            $(document).on('focus','input, textarea', function (e) {
                $(this).parents('.form-group').addClass('focused');
            });

            $(document).on('blur','input, textarea, select', function (e) {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            $(document).on('change','select', function (e) {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('.nice-select').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                $(this).niceSelect('update');
            })

            // Make all 'disabled' values actually disabled - not available in form builder
            $("option:selected").each(function () {
                let $option = $(this);
                if ($option.val() === 'disabled') {
                    $option.attr('disabled', true);
                    $option.attr('selected', true);
                }
            });

            // Add '*' to required fields
            $('input:required, select:required, textarea:required').each(function () {
                let $label = $(this).parents('.form-group').find('label');
                $label.addClass('required');
            });

            $('form input, form textarea').on('focus', function() {
                $(this).parents('.form-group').addClass('focused');
            });
        
            $('.file-uploader input[type=file]').on('change', function (e) {
                if (e.target.files.length > 0) {
                    let $fileName = e.target.files[0].name;
                    $(this).parent().find('.fake-input').html($fileName)
                } else {
                    $(this).parent().find('.fake-input').html($(this).parent().data('label'))
                }
            });

            $('form .ajax-submit').on('click', function(){
                var page = $(this).parents('form').find('[name="page"]').val();

                if(typeof(page) != 'undefined') {
                    helpers.setUrlParameter('page', page);
                }
            });

            $('form input[type="file"]').on('change', function(){
                var file_data = $(this).prop('files')[0];   
                var form_data = new FormData($(this).parents('form')[0]);                  
                form_data.append('file', file_data);                            
                $.ajax({
                    url: '/displayForm/onUpdateFile',
                    dataType: 'text',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form_data,                         
                    type: 'post',
                    success: function(php_script_response){
                        console.log(php_script_response);
                    }, error: function(error){
                        console.log(error);
                    }
                });
            });

            $('.js-prefill').each(function(){
                var $form = $(this);
                if($form.data('prefill') !== undefined){
                    var prefill = $form.data('prefill');
                    setTimeout(function(){
                        $.each(prefill, function(key, value){
                            if(!['submit','url','form','g-recaptcha-response','pdf','home','facade','saved_homes','houseland','home_or_package','situation'].includes(key)){
                                var $input = $form.find('[name="'+key+'"]');
                                if($input.attr('type') == 'checkbox' || $input.attr('type') == 'radio'){
                                    if(value == null || value == undefined || value == ''){
                                        $input.prop('checked', false);
                                    }else{
                                        $input.filter('[value="'+value+'"]').prop('checked', true);
                                    }
                                    $input.trigger('change');
                                }else{
                                    $form.find('[name="'+key+'"]').val(value);
                                    $form.find('[name="'+key+'"]').trigger('change')
                                }
                            }else if(['situation'].includes(key)){
                                if($form.find('[name="'+key+'"]').attr('type') == 'checkbox' || $form.find('[name="'+key+'"]').attr('type') == 'radio'){
                                    $form.find('[name="'+key+'"][value="'+value+'"]').prop('checked', true);
                                }else{
                                    $form.find('[name="'+key+'"]').val(value);
                                }
                                $form.find('[name="'+key+'"]').trigger('change');
                            }
                        });
                        $form.find('.nice-select').niceSelect('update');
                    }, 1000);
                }
            });

            var $pageTitleInput = $('.js-page-title-input');
            if($pageTitleInput.length){
                $pageTitleInput.val(document.title);
            }

            let $requiredConsentForm = $('.js-required-consent');
            if($requiredConsentForm.length){
                let $parent = $('.js-required-consent [name="consent"]').parents('.form-group')
                $parent.addClass('d-flex flex-column align-items-start alert-errors');
            }

            let $lotWidthLogicForm = $('.js-lot-width-logic');
            if($lotWidthLogicForm.length){
                let width = $lotWidthLogicForm.data('lot-width');
                if(width !== undefined){
                    let $field = $lotWidthLogicForm.find('[name="lot_width"]');
                    let $parent = $field.parents('.form-group');
                    let $prompt = $lotWidthLogicForm.find('.js-lot-width-prompt');
                    let $continue = $lotWidthLogicForm.find('.js-lot-width-continue');

                    $field.on('change', function(){
                        if($(this).val() > 0 && parseFloat($(this).val()) < parseFloat(width)){
                            $parent.addClass('d-flex flex-column align-items-start');
                            $prompt.show();
                            if($prompt.parents('.form-group').length <= 0){
                                $parent.append($prompt);
                            }
                        }else{
                            $prompt.hide();
                        }
                    });

                    $continue.on('click', function(){
                        $prompt.remove();
                    });
                }
            }
        });
        //////////////////////////////////////////////
        // Paginate Hook
        //////////////////////////////////////////////
        // Listen for ajax success events & jump the page to the results
        $(document).ajaxSuccess(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    /*if($(window).scrollTop() > 0) {
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top
                        }, 100);
                    }*/
                    paginateHook();
                }
                onSuccess(xhr.target);
            }
        });
        $(document).ajaxError(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    /*if($(window).scrollTop() > 0) {
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top
                        }, 100);
                    }*/
                    paginateHook();
                }
                onError(xhr.target);
            }
        });
        function getParam(name, url) {
            if (!url)
                url = location.href;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results === null ? null : results[1];
        }
        function paginateHook() {
            $('.pagination a').on('click', function (e) {
                e.preventDefault();
                var page = getParam('page', $(this).attr('href'));
                var form = $(this).parents('[data-form]').data('form');
                $(form).find('.current-page').val(page);
                $(form).find('.ajax-submit').trigger('click');
                $('html, body').animate({
                    scrollTop: $('#results').offset().top
                }, 100);
            });
        }

        // Checkbox auto refresh
        $('.filter-container input[type=checkbox]').on('change', function() {
            $(this).parents('form').find('.current-page').val(1);
            $(this).parents('form').find('.ajax-submit').trigger('click');
        });

        paginateHook();
    };

    const onSuccess = (form) => {
        var offset = $(form).offset().top;

        $(form).find('.alert-success').addClass('show');
        $(form).find('.alert-danger').removeClass('show');
        if($(window).scrollTop() > 0 && offset > 0 && $(form).find('.alert').length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: offset
            }, 200);
        }
    };
    
    const onError = (form) => {
        var offset = $(form).offset().top;
        
        $(form).find('.alert-danger').addClass('show');
        $(form).find('.alert-success').removeClass('show');
        if($(window).scrollTop() > 0 && offset > 0 && $(form).find('.alert').length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: offset
            }, 200);
        }
    };

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError
    };
};

export default Forms;